import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocation, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import useTranslationHook from "../../../../hooks/useTranslationHook";
import useIPAddress from "../../../../hooks/useIPAddress";

import ReactSelect from "../../../../common/ReactSelect";
import DateSelector from "../../../../home/common/DateSelector";
import BidderRegistrationAgreementModal from "../modals/BidderRegistrationAgreementModal";

import {
  SelfStepOneFormValidationSchema,
  PrincipalStepOneFormValidationSchema,
  SelfStepOneFormLiveValidationSchema,
} from "../../../../../utils/validations/buyerValidation";

import {
  BUYER_REGISTRATION_STEPS,
  EMPTY,
  ID_TYPE,
  RegistrationFlowType,
  Set_Bid_Registration_Doc,
} from "./constant";

import {
  setCities,
  setCountries,
} from "../../../../../redux/action/sellerAction";

import {
  updateBuyerRegistrationField,
} from "../../../../../redux/slice/buyerSlice";

import { handleAuctionBidRegistration } from "../../../../../redux/action/buyerAction";
import { DOMAIN } from "../../../../../utils/constants";
import { guessDateTime } from "../../../../../utils/dateUtils";
import { makeFullName, splitAndCombine } from "../../../../../utils";
import { toast } from "react-toastify";
import Tooltip from "rc-tooltip";
import useDidMountEffect from "../../../../hooks/useDidMountEffect";
import MobileInput from "../../../../common/form/MobileInput";
import { handleKeyDown, initializeIntlTelInput } from "../../../../../helpers";
import { handleSelection } from "../../../../../redux/slice/liveAuctionSlice";
import FileUploadItem from "../../../../seller/property/FileUploadItem";

const RegistrationDetails = ({ onDirtyChange }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ip } = useIPAddress();
  const { t } = useTranslationHook();
  const inputRef = useRef(null);
  const [state, setState] = useState({
    countryCode: "",
    countryCodeIsoName: "",
  });
  const [docsDirty, setDocsDirty] = useState(false);
  const { principalIdDoc, powerOfAttorneyDoc } = useSelector(
    (state) => state.buyer.buyerRegistration.principal.stepTwoData
  );
  // const lots = useSelector((state) => state.liveAuction.lots);
  const selectedSessionRef = useRef();
  const location = useLocation();
  const { selectedSessionID, lotID } = location?.state || {};

  // const selectedSession = useSelector((state) => state.liveAuction.selectedSession);
  // const selectedLot = useSelector((state) => state.liveAuction.selectedLot);

  const registrationType = useSelector(
    (state) => state.buyer.buyerRegistration.registrationType
  );
  const { isSelf, isPrincipal } = useMemo(() => ({
    isSelf: registrationType === RegistrationFlowType.SELF,
    isPrincipal: registrationType === RegistrationFlowType.PRINCIPAL,
  }), [registrationType]);

  const stepOneData = useSelector((state) =>
    isSelf
      ? state.buyer.buyerRegistration.self.stepOneData
      : state.buyer.buyerRegistration.principal.stepOneData
  );

  const lang = useSelector((state) => state.translation.lang);
  const property_id = useSelector((state) => state.buyer.buyerRegistration.property_id);



  const isBidderRegistrationModalOpen = useSelector(
    (state) => state.buyer.buyerRegistration.isBidderRegistrationModalOpen
  );

  const countries = useSelector((state) => state.seller.countries);

  const cityList = useSelector((state) =>
    isSelf
      ? state.buyer.buyerRegistration.self.stepOneData.cityList
      : EMPTY
  );

  const today = new Date();
  const eighteenYearsAgo = new Date();
  eighteenYearsAgo.setFullYear(today.getFullYear() - 18);

  const tomorrow = today.setDate(today.getDate() + 1);

  const setBuyerField = useCallback((field, value) => {
    dispatch(updateBuyerRegistrationField({ field, value }));
  }, []);

  const registration_id = useSelector(
    (state) => state.buyer.buyerRegistration.registration_id
  );

  const getCleanFormData = useCallback((data) => {
    if (!data) return {};

    if (isSelf) {
      return {
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        dob: data.dob || null,
        nationality: data.nationality || null,
        phone: data.phone || "",
        email: data.email || "",
        country: data.country || null,
        city: data.city || null,
        address_first: data.address_first || "",
      };
    }

    if (isPrincipal) {
      return {
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        id_type: data.id_type || null,
        id_number: data.id_number || "",
        poa_expiry_date: data.poa_expiry_date || null,
        phone: data.phone || "",
        email: data.email || "",
      };
    }

    return {};
  }, [isSelf, isPrincipal]);

  const {
    watch,
    register,
    control,
    reset,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors, isDirty, isValid },
  } = useForm({
    defaultValues: {
      // ...({ ...stepOneData, ...(selectedSessionID && stepOneData?.isKycAvailable && { city: "3396" }) }),
      ...(stepOneData),
      // ...(selectedSessionRef.current && {
      //   lots: [
      //     ...new Set([
      //       ...(registration_id ? (stepOneData?.lots || []) :
      //         lots?.data
      //           ?.filter((item) => item.id === lotID)
      //           .map((item) => item.id) || []
      //       )
      //     ]),
      //   ],
      // }),
    },
    mode: "all",
    resolver: yupResolver(
      isSelf
        // ? selectedSessionID ? SelfStepOneFormLiveValidationSchema : SelfStepOneFormValidationSchema
        ?  SelfStepOneFormLiveValidationSchema 
        : PrincipalStepOneFormValidationSchema
    ),
  });


  const isPrincipalDocsValid = useMemo(() => {
    if (registrationType !== RegistrationFlowType.PRINCIPAL) return true;

    return Boolean(
      principalIdDoc?.upload_id &&
      powerOfAttorneyDoc?.upload_id
    );
  }, [registrationType, principalIdDoc, powerOfAttorneyDoc]);

  const isStepValid = isValid && isPrincipalDocsValid;
  const country = useWatch({
    control,
    name: "country",
  });



  useEffect(() => {
    selectedSessionRef.current = selectedSessionID;
  }, [selectedSessionID]);


  useDidMountEffect(() => {
    // reset(getCleanFormData({ ...stepOneData, ...(selectedSessionID && stepOneData?.isKycAvailable && { city: "3396" }) }));
    reset(getCleanFormData(stepOneData));
    onDirtyChange(false);
    setDocsDirty(false);
  }, [registrationType]);

  useEffect(() => {
    if (isDirty) onDirtyChange(isDirty);
  }, [isDirty]);

  useEffect(() => {
    if (!isSelf) return;
    if (!countries?.length) dispatch(setCountries());
  }, [isSelf, countries]);

  useEffect(() => {
    if (!country) return;
    dispatch(
      setCities({ country_id: country })
    );
  }, [country]);

  useEffect(() => {
    if (!isSelf) return;
    const nationality = countries?.find(
      // c => (selectedSessionID ? state?.countryCodeIsoName?.toLocaleLowerCase().includes(c.label.toLowerCase()) : c?.iso_name === stepOneData?.issuing_country_code)
      c => (registrationType === RegistrationFlowType.SELF ? state?.countryCodeIsoName?.toLocaleLowerCase().includes(c.label.toLowerCase()) : c?.iso_name === stepOneData?.issuing_country_code)
    )?.value;
    if (!nationality) return;
    setValue("nationality", nationality, { shouldValidate: true });
    dispatch(
      updateBuyerRegistrationField({
        section: RegistrationFlowType.SELF,
        stepKey: "stepOneData",
        value: { nationality }
      })
    );
  }, [isSelf, countries, stepOneData?.issuing_country_code, state?.countryCodeIsoName]);
  useEffect(() => {
    if (!isSelf) return;
    const country = countries?.find(
      // c => (selectedSessionID ? state?.countryCodeIsoName?.toLocaleLowerCase().includes(c.label.toLowerCase()) : c?.iso_name === stepOneData?.country_name)
      c => (registrationType === RegistrationFlowType.SELF ? state?.countryCodeIsoName?.toLocaleLowerCase().includes(c.label.toLowerCase()) : c?.iso_name === stepOneData?.country_name)
    )?.value;
    if (!country) return;
    setValue("country", country, { shouldValidate: true });
    dispatch(
      updateBuyerRegistrationField({
        section: RegistrationFlowType.SELF,
        stepKey: "stepOneData",
        value: { country }
      })
    );
  }, [isSelf, countries, stepOneData?.country_name,state?.countryCodeIsoName]);

  useEffect(() => {
    if (!isSelf) return;
    const city = cityList?.find(
      c => c?.state_name?.toLowerCase() === stepOneData?.state_name?.toLowerCase()
    )?.value;

    if (!city) return;
    setValue("city", city, { shouldValidate: true });
    dispatch(
      updateBuyerRegistrationField({
        section: RegistrationFlowType.SELF,
        stepKey: "stepOneData",
        value: { city }
      })
    );
  }, [isSelf, cityList, stepOneData?.state_name]);

  useEffect(() => {
    const isSelf=registrationType === RegistrationFlowType.SELF?true:false
    initializeIntlTelInput({
      inputRef,
      // countryCode: isSelf ? stepOneData?.phone_country_code ?? "971" : "971",
      countryCode: stepOneData?.phone_country_code ?? "971",
      setState,
      // selectedSessionID,
      isSelf
    });
    return () => {
      const scriptToRemove =
        document.getElementById("intlTelInputScript");
      if (scriptToRemove) scriptToRemove.remove();

      const stylesheetToRemove = document.getElementById(
        "intlTelInputStylesheet"
      );
      if (stylesheetToRemove) stylesheetToRemove.remove();
    };
    //eslint-disable-next-line
  }, [registrationType]);


  const goToNextStep = () => {
    const currentSession = selectedSessionRef.current;
    if (isSelf) {
      currentSession ?
        setBuyerField("step", BUYER_REGISTRATION_STEPS.LOTS_SELECTION)

        : setBuyerField("isBidderRegistrationModalOpen", true);
    }

    if (isPrincipal) {
      currentSession ?
        setBuyerField("step", BUYER_REGISTRATION_STEPS.LOTS_SELECTION) :
        setBuyerField("step", BUYER_REGISTRATION_STEPS.PRINCIPAL_DOCS);
    }
  };

  const submitRegistrationDetail = async (formData) => {
    // if (isPrincipal && !isPrincipalDocsValid) {
    //   toast.error("Please upload required documents");
    //   return;
    // }
    if (!formData) return;
    const currentSession = selectedSessionRef.current;

    setValue("phone_country_code", state.countryCode)

    if (Boolean(stepOneData?.completed) && !isDirty && !docsDirty) {
      goToNextStep();
      return;
    }

    const { firstName, lastName, phone, dob, poa_expiry_date, completed, ...rest } = formData;

    // const { countryCode, phoneNumber } = splitAndCombine(phone);

    const formattedDob = dob
      ? guessDateTime(dob, "YYYY-MM-DD")
      : undefined;

    const formattedPoaExpiryDate = poa_expiry_date
      ? guessDateTime(poa_expiry_date, "YYYY-MM-DD")
      : undefined;


    const payload = {
      ...(registration_id && !currentSession && { bid_registration: registration_id }),
      ...(registration_id && currentSession && { registration_id: registration_id }),
      step: 1,
      registration_type: isSelf ? 1 : 2,
      domain: DOMAIN,
      ...(!currentSession && { property: property_id }),
      ...(currentSession && { auction_session: currentSession }),
      ip_address: ip ?? "127.0.0.1",
      email: rest.email,
      first_name: makeFullName(firstName, lastName),
      // phone_country_code: stepOneData?.isKycAvailable && selectedSessionID ? stepOneData?.phone_country_code : state.countryCode,
      phone_country_code: stepOneData?.isKycAvailable ? stepOneData?.phone_country_code : state.countryCode,
      phone_no: phone,
      // ...(currentSession && { lots: formData.lots }),
      ...(!isSelf && selectedSessionID && {
        documents: { "principal_id_document": principalIdDoc?.upload_id ?? null, "power_of_attorney_document": powerOfAttorneyDoc?.upload_id ?? null }
      })
    };

    if (isSelf) {
      Object.assign(payload, {
        address_first: rest.address_first,
        city: rest.city,
        country: rest.country,
        nationality: rest.nationality,
        dob: formattedDob,
      });
    }

    if (isPrincipal) {
      Object.assign(payload, {
        id_type: rest.id_type,
        id_number: rest.id_number,
        poa_expiry_date: formattedPoaExpiryDate
      });
    }


    const response = await dispatch(handleAuctionBidRegistration(payload));

    const { code, error, msg, data } = response || {};

    if (code !== 1 || error !== 0) {
      toast.info(msg || "Something went wrong");
      // console.info("Registration Detail Error:", response);
      return;
    }

    toast.success(msg);
    setBuyerField("registration_id", data?.registration_id);

    dispatch(
      updateBuyerRegistrationField({
        section: registrationType,
        stepKey: "stepOneData",
        value: {
          ...formData,
          completed: true,
          ...(isSelf && { dob: formattedDob }),
          ...(isPrincipal && { poa_expiry_date: formattedPoaExpiryDate }),
        },
      })
    );
    setDocsDirty(false);
    goToNextStep();
  };


  return (
    <form onSubmit={handleSubmit(submitRegistrationDetail)}>
      {/* {stepOneData?.isKycAvailable && selectedSessionID && isSelf ? <></> : <> */}
      {stepOneData?.isKycAvailable && isSelf ? <></> : <>
        <div className={selectedSessionID && !isSelf ? "register-for-someone" : ""}>
          {stepOneData?.isKycAvailable && state?.selectedSessionID ? <></> : <h6>{t("Please Fill Personal Details")}</h6>}
          <div className="row">

            <div className="col-lg-6 mb-3">
              <label className="form-label">
                {isPrincipal ? t("PrincipalsFirstName") : t("FirstName")}*
              </label>
              <input
                type="text"
                placeholder={t("EnterFirstName")}
                className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                {...register("firstName")}
              />
              {errors.firstName && <div className="invalid-feedback">{t(errors.firstName.message)}</div>}
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">
                {isPrincipal ? t("PrincipalsLastName") : t("LastName")}*
              </label>
              <input
                type="text"
                placeholder={t("EnterLastName")}
                className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                {...register("lastName")}
              />
              {errors.lastName && <div className="invalid-feedback">{t(errors.lastName.message)}</div>}
            </div>

            {isSelf && (
              <>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("DateOfBirth")}*</label>
                  <div className="date-picker">
                    <DateSelector
                      control={control}
                      name="dob"
                      className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                      placeholderText={t("YYYY-MM-DD")}
                      dateFormat="yyyy-MM-dd"
                      showYearDropdown
                      scrollableMonthYearDropdown
                      openToDate={
                        eighteenYearsAgo
                      }
                      maxDate={eighteenYearsAgo}
                    />
                  </div>
                  {errors.dob && (
                    <div className="invalid-feedback d-block">
                      {t(errors.dob.message)}
                    </div>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("Nationality")}*</label>
                  <ReactSelect
                    name="nationality"
                    control={control}
                    options={countries}
                    isSearchable
                    placeholder={t("EnterNationality")}
                    className={`select ${errors.nationality ? "is-invalid" : ""}`}

                  />
                  {errors.nationality && (
                    <div className="invalid-feedback">
                      {t(errors.nationality.message)}
                    </div>
                  )}
                </div>
              </>
            )}

            {isPrincipal && (
              <>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("PrincipalsIdType")}*</label>
                  <ReactSelect
                    name="id_type"
                    control={control}
                    options={ID_TYPE}
                    isSearchable
                    placeholder={t("SelectIdType")}
                    className={`select ${errors.id_type ? "is-invalid" : ""}`}
                  />
                  {errors.id_type && (
                    <div className="invalid-feedback">
                      {t(errors.id_type.message)}
                    </div>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("PrincipalsIdNumber")}*</label>
                  <input
                    className={`form-control ${errors.id_number ? "is-invalid" : ""}`}
                    placeholder={t("SelectIdNumber")}
                    {...register("id_number")}
                  />
                  {errors.id_number && (
                    <div className="invalid-feedback">
                      {t(errors.id_number.message)}
                    </div>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("PoaExpiryDate")}*</label>
                  <div className="date-picker">
                    <DateSelector
                      control={control}
                      name="poa_expiry_date"
                      className={`form-control ${errors.poa_expiry_date ? "is-invalid" : ""}`}
                      placeholderText={t("YYYY-MM-DD")}
                      dateFormat="yyyy-MM-dd"
                      showYearDropdown
                      scrollableMonthYearDropdown
                      minDate={tomorrow}
                    />
                  </div>
                  {errors.poa_expiry_date && (
                    <div className="invalid-feedback d-block">
                      {t(errors.poa_expiry_date.message)}
                    </div>
                  )}
                </div>
              </>
            )}

            <div className="col-lg-6 mb-3" key={registrationType}>
              <label className="form-label">
                {t("PrincipalsPhone")}*
                <Tooltip
                  overlay={
                    <span>
                      {t(
                        "No need to include the country code (e.g., +971 for UAE)"
                      )}
                    </span>
                  }
                  placement="top"
                >
                  <span className="ms-2 text-info">
                    <i className="fas fa-info-circle" />
                  </span>
                </Tooltip>
              </label>

              <MobileInput
                type={"tel"}
                id={"phone_number"}
                className={"form-control"}
                placeholder={t("Phone Number")}
                inputRef={inputRef}
                register={register}
                name={"phone"}
                errors={errors}
                onKeyDown={handleKeyDown}
                maxLength={15}
              />

              {/* <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <PhoneInput
                {...field}
                country="ae"
                onlyCountries={["ae"]}
                countryCodeEditable={false}
                inputClass={`form-control ${errors.phone ? "is-invalid" : ""
                  }`}
                inputStyle={{ width: "100%" }}
                onChange={(
                  value
                ) => {
                  field.onChange(
                    value
                  );
                }}
                inputProps={{
                  ref: field.ref
                }}
              />
            )}
          />
          {errors.phone && (
            <div className="invalid-feedback d-block">
              {t(errors.phone.message)}
            </div>
          )} */}
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">{isPrincipal ? t("PrincipalsEmail") : t("Email")}*</label>
              <input
                type="email"
                placeholder={t("EnterEmailId")}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                {...register("email")}
              />
              {errors.email && (
                <div className="invalid-feedback d-block">
                  {t(errors.email.message)}
                </div>
              )}
            </div>

            {isSelf && (
              <>
                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("Country")}*</label>
                  <ReactSelect
                    name="country"
                    control={control}
                    options={countries}
                    isSearchable
                    placeholder={t("EnterCountry")}
                    className={`select ${errors.country ? "is-invalid" : ""}`}
                  />
                  {errors.country && (
                    <div className="invalid-feedback">
                      {t(errors.country.message)}
                    </div>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("City") + "*"}</label>
                  <ReactSelect
                    name="city"
                    isSearchable
                    control={control}
                    options={cityList}
                    placeholder={t("SelectACity")}
                    className={`select ${errors.city ? "is-invalid" : ""}`}
                  />
                  {errors.city && (
                    <div className="invalid-feedback d-block">
                      {t(errors.city.message)}
                    </div>
                  )}
                </div>

                <div className="col-lg-6 mb-3">
                  <label className="form-label">{t("AddressLine1")}</label>
                  <input
                    type="text"
                    className={`form-control ${errors.address_first ? "is-invalid" : ""
                      }`}
                    placeholder={t("EnterAddress")}
                    {...register("address_first")}
                  />
                  {errors.address_first && (
                    <div className="invalid-feedback">
                      {t(errors.address_first.message)}
                    </div>
                  )}
                </div>
              </>
            )}
            {/* {selectedSessionRef?.current ? <div className="col-lg-6 mb-3">
          <label className="form-label">{t("Lots")}</label>
          <ReactSelect
            name="lots"
            isMulti={true}
            control={control}
            options={lots?.data?.map((item) => ({ label: lang === "en" ? item.property_name : item.property_name_ar, value: item.id }))}
            isSearchable
            placeholder={t("Pick one or more lots")}
            className={`select ${errors.lots ? "is-invalid" : ""}`}

          />
          {errors.lots && (
            <div className="invalid-feedback">
              {t(errors.lots.message)}
            </div>
          )}
        </div> :
          <></>} */}





          </div>
        </div>
        {isPrincipal && selectedSessionID && <div className="register-for-someone">
          <h6>
            Documents
          </h6>
          <ul className="doc-list">

            <FileUploadItem
              iconSrc="/img/documents-icon.svg"
              title={t("PrincipalsIdDocument")}
              required={true}
              subtitle={!principalIdDoc && t("1 Image Required")}
              bucketName="bidder_document"
              section="documents"
              property="principalIdDoc"
              documents={principalIdDoc}
              docType="16"
              allowMultiple={false}
              module={Set_Bid_Registration_Doc}
              onDocumentChange={() => setDocsDirty(true)}
            />

            <FileUploadItem
              iconSrc="/img/documents-icon.svg"
              title={t("PowerOfAttorneyDocument")}
              required={true}
              subtitle={!powerOfAttorneyDoc && t("1 Image Required")}
              bucketName="bidder_document"
              section="documents"
              property="powerOfAttorneyDoc"
              documents={powerOfAttorneyDoc}
              docType="16"
              allowMultiple={false}
              module={Set_Bid_Registration_Doc}
              onDocumentChange={() => setDocsDirty(true)}
            />

          </ul>

        </div>}
      </>}


      <div className={`bidder-btns ${stepOneData?.isKycAvailable ? "mt-4" : "mb-4"}`}>
        <button type="button" onClick={() => navigate(-1)} className="btn btn-sky back-btn">
          <img src="/img/arrow-left.svg" className="mr4" alt="" /> {t("Back")}
        </button>
        <button type="submit" disabled={!(selectedSessionID ? isStepValid : isValid)} className="btn btn-primary forward-btn">
          {t("Next")} <img src="/img/arrow-right.svg" className="ml4" alt="" />
        </button>
      </div>

      {isSelf && isBidderRegistrationModalOpen && (
        <BidderRegistrationAgreementModal
          show={isBidderRegistrationModalOpen}
          onClose={() => setBuyerField("isBidderRegistrationModalOpen", false)}
          proceedToPaymentStep={() => {
            setBuyerField("step", BUYER_REGISTRATION_STEPS.PAYMENT);
            setBuyerField("isBidderRegistrationModalOpen", false);
          }}
        />
      )}
    </form>
  );
};

export default RegistrationDetails;

